import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateCustomerReferenceRequest,
  useVbsWorkOrderUpdateCustomerReferenceMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import t from "@/lang/lang";
import { TextInputField } from "@/shared/components/field/input-field";

export function WorkOrderCustomerReferenceInput({
  workOrder,
  disabled,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateCustomerReferenceRequest>({
    id: workOrder.id,
    customerReference: workOrder.customerReference,
  });
  const mutation = useVbsWorkOrderUpdateCustomerReferenceMutation();

  useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    customerReference: workOrder.customerReference,
  });

  return (
    <TextInputField
      label={t("Kundenreferenz")}
      text={request.customerReference}
      onTextChange={(customerReference) =>
        setRequest({ ...request, customerReference })
      }
      fieldName="customerReference"
      debounce={false}
      disabled={disabled}
    />
  );
}
